import {
  Avatar,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Grid,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import BusinessIcon from "@mui/icons-material/Business";
import CallIcon from "@mui/icons-material/Call";
import CakeIcon from "@mui/icons-material/Cake";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import AppButton from "../shares/AppButton";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { Edit, GitHub, LinkedIn } from "@material-ui/icons";
import { getAccountTypeNameByCode, NA } from "../../../utils/utilities";
import { handleCopy, showFullName } from "../../../Helpers/utilsHelper";
import { CopyAllOutlined } from "@mui/icons-material";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import ChangePasswordForm from "./ChangePasswordForm";
import IdentiteForm from "./etat_civile/IdentiteForm";
import ChangeAccountType from "./ChangeAccountType";

const Information = ({ user_info, reload, loading = false }) => {
  const { showToast, Toast } = useToast();
  const [changePwdFormOpen, setChangePwdFormOpen] = useState(false);
  const [changeAccountTypeOpen, setChangeAccountTypeOpen] = useState(false);
  const [identityFormOpen, setIdentityFormOpen] = useState(false);

  const handleCopyToClipBoard = (text) => {
    handleCopy(text).then((res) => {
      if (res) {
        showToast(TYPE_NOTIFICATION.SUCCESS, "Copié");
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, "Erreur de copie");
      }
    });
  };


  const handleOpenIdentityForm = () => {
    setIdentityFormOpen(true);
  };

  const handleCloseChangeAccontTypeForm = () => {
    setChangeAccountTypeOpen(false);
    reload();
  };

  const handleOpenChangeAccontTypeForm = () => {
    setChangeAccountTypeOpen(true);
  };

  const handleCloseIdentityForm = () => {
    setIdentityFormOpen(false);
    reload();
  };

  const handleOpenPwdChangeForm = () => {
    setChangePwdFormOpen(true);
  };
  const handleClosePwdChangeForm = () => {
    setChangePwdFormOpen(false);
  };

  return (
    <>
      <ChangeAccountType
        open={changeAccountTypeOpen}
        onFormClose={handleCloseChangeAccontTypeForm}
      />
      <IdentiteForm
        idMembre={null}
        open={identityFormOpen}
        onFormClose={handleCloseIdentityForm}
      />
      <ChangePasswordForm
        open={changePwdFormOpen}
        onFormClose={(e) => handleClosePwdChangeForm()}
      />
      <Toast />
      <Grid container m={2} display={loading ? "none" : ""}>
        <Skeleton width={"100%"} />
        <Skeleton width={"100%"} />
        <Skeleton width={"100%"} />
        <Skeleton width={"100%"} />
      </Grid>
      <Grid
        container
        display={!loading ? "none" : "flex"}
        flexDirection={"row"}
        mr={2}
      >
        <Grid item xs={12}>
          <Paper>
            <CardContent>
              <Grid>
                <CardHeader
                  title={
                    user_info.is_association !== "0"
                      ? "Informations du compte gerant"
                      : "Mes informations"
                  }
                />
                <Grid
                  container
                  display={"flex"}
                  m={3}
                  alignItems={"center"}
                  flexDirection={"row"}
                >
                  <Grid>
                    <Avatar
                      sx={{
                        m: 1,
                        width: "clamp(100px, 15vw, 150px)",
                        height: "clamp(100px, 15vw, 150px)",
                        fontSize: "clamp(40px, 8vw, 80px)",
                      }}
                      alt={showFullName(user_info.nom, user_info.prenoms)}
                      src={user_info.photo_link}
                    />
                  </Grid>
                  <Grid flexGrow={1}>
                    <CardHeader
                      subheader={
                        <Grid>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <WorkOutlineIcon />
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "0.95rem",
                                  sm: "1.05rem",
                                  md: "1.15rem",
                                },
                                wordBreak: "break-word",
                              }}
                            >
                              {`${user_info.fonction || NA()}`}
                            </Typography>
                          </Stack>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <BusinessIcon />
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "0.95rem",
                                  sm: "1.05rem",
                                  md: "1.15rem",
                                },
                                wordBreak: "break-word",
                              }}
                            >
                              {`${user_info.adresse || NA()}`}
                            </Typography>
                          </Stack>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <CakeIcon />
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "0.95rem",
                                  sm: "1.05rem",
                                  md: "1.15rem",
                                },
                              }}
                            >
                              {`${user_info.annee_naissance ? new Date().getFullYear() - user_info.annee_naissance : "NA"} ans`}
                            </Typography>
                          </Stack>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <CallIcon />
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "0.95rem",
                                  sm: "1.05rem",
                                  md: "1.15rem",
                                },
                                wordBreak: "break-word",
                              }}
                            >
                              {` ${user_info.telephone1 || NA()} / ${user_info.telephone2 || ""}`}
                            </Typography>
                          </Stack>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <EmailOutlinedIcon />
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "0.95rem",
                                  sm: "1.05rem",
                                  md: "1.15rem",
                                },
                                wordBreak: "break-word",
                              }}
                            >
                              {`${user_info.email || NA()}`}
                            </Typography>
                          </Stack>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <LinkedIn />
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "0.95rem",
                                  sm: "1.05rem",
                                  md: "1.15rem",
                                },
                                wordBreak: "break-word",
                              }}
                            >
                              {`${user_info.linkedin || NA()}`}
                            </Typography>
                          </Stack>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <GitHub />
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "0.95rem",
                                  sm: "1.05rem",
                                  md: "1.15rem",
                                },
                                wordBreak: "break-word",
                              }}
                            >
                              {`${user_info.github || NA()}`}
                            </Typography>
                          </Stack>
                        </Grid>
                      }
                      component="div"
                      title={
                        <Grid item xs={8}>
                          <Typography
                            property="name"
                            sx={{
                              fontSize: {
                                xs: "1.1rem",
                                sm: "1.3rem",
                                md: "1.6rem",
                              },
                              fontWeight: 600,
                              wordBreak: "break-word",
                            }}
                          >
                            {showFullName(user_info.nom, user_info.prenoms)}
                          </Typography>
                        </Grid>
                      }
                    />
                  </Grid>
                </Grid>
                {/* <CardActions
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <AppButton
                    color={"primary"}
                    text={"Mettre à jour"}
                    icon={<ModeEditOutlineOutlinedIcon />}
                  />
                </CardActions> */}
              </Grid>
              <Divider variant="middle" />
              <Grid>
                <CardHeader title={"Description"} />
                <CardContent>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "0.95rem",
                        sm: "1.05rem",
                        md: "1.15rem",
                      },
                      wordBreak: "break-word",
                    }}
                  >
                    {user_info.description}
                  </Typography>
                </CardContent>
                <CardActions
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <AppButton
                    color={"primary"}
                    onClick={(e) => handleOpenIdentityForm()}
                    text={"Mettre à jour"}
                    icon={<ModeEditOutlineOutlinedIcon />}
                  />
                </CardActions>
              </Grid>
            </CardContent>
          </Paper>
        </Grid>
        <Grid item xs={12} id={"type_du_compte"} mt={1}>
          <Paper>
            <CardContent>
              <Grid>
                <CardHeader title="Compte" />
                <CardContent>
                  <CardHeader
                    title="Type du compte"
                    titleTypographyProps={{ variant: "h6" }}
                    subheader={
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        <Chip
                          label={getAccountTypeNameByCode(
                            user_info.is_association || 0
                          )}
                          variant="outlined"
                          color="primary"
                        />
                      </Typography>
                    }
                  />
                </CardContent>
                <CardActions
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <AppButton
                    color={"primary"}
                    text={"Modifier"}
                    icon={<ModeEditOutlineOutlinedIcon />}
                    onClick={(e) => handleOpenChangeAccontTypeForm(user_info)}
                  />
                </CardActions>
              </Grid>
            </CardContent>
          </Paper>
        </Grid>
        <Grid item xs={12} mt={1}>
          <Paper>
            <CardContent>
              <Grid>
                <CardHeader title="Sécurité" />
                <CardContent>
                  <CardHeader
                    title="Identifiant"
                    titleTypographyProps={{ variant: "h6" }}
                    subheader={
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {user_info.uuid}
                      </Typography>
                    }
                  />
                </CardContent>
                <CardActions
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <AppButton
                    color={"primary"}
                    text={"Copier"}
                    icon={<CopyAllOutlined />}
                    onClick={(e) => handleCopyToClipBoard(user_info.uuid)}
                  />
                </CardActions>
              </Grid>
              <Divider variant="middle" />
              <Grid>
                <CardContent>
                  <CardHeader
                    title="Adresse email"
                    titleTypographyProps={{ variant: "h6" }}
                    subheader={
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {user_info.email}
                      </Typography>
                    }
                  />
                </CardContent>
                <CardActions
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <AppButton
                    color={"primary"}
                    text={"Mettre à jour"}
                    icon={<ModeEditOutlineOutlinedIcon />}
                  />
                </CardActions>
              </Grid>
              <Divider variant="middle" />
              <Grid>
                <CardContent>
                  <CardHeader
                    title="Mot de passe"
                    titleTypographyProps={{ variant: "h6" }}
                    subheader={
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        ******************
                      </Typography>
                    }
                  />
                </CardContent>
                <CardActions
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <AppButton
                    color={"primary"}
                    onClick={(e) => handleOpenPwdChangeForm()}
                    text={"Mettre à jour"}
                    icon={<ModeEditOutlineOutlinedIcon />}
                  />
                </CardActions>
              </Grid>
            </CardContent>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default Information;
